import React, { useState } from 'react';
import styles from './BreedSelectOverlay.module.scss';
import biotailLogo from '../../../Assets/Images/biotail_logo.svg';
import { useTranslate } from 'react-polyglot';

interface BreedSelectOverlayProps {
    breeds: Array<{ ID: string; NAME: string }>;
    onSelect: (breedId: string) => void;
    logo?: string | null;
    brandName?: string;
}

function BreedSelectOverlay({ breeds, onSelect, logo, brandName = 'Biotail AvlsPortal' }: BreedSelectOverlayProps) {
    const t = useTranslate();
    const [selected, setSelected] = useState('');

    function handleConfirm() {
        if (selected) {
            onSelect(selected);
        }
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.panel}>
                {logo
                    ? <img src={`data:image/*;base64,${logo}`} alt={brandName} className={styles.logo} />
                    : <img src={biotailLogo} alt="Biotail Logo" className={styles.logo} />
                }
                <h1 className={styles.title}>{brandName}</h1>
                <p className={styles.subtitle}>{t("externalportal.breedselect.subtitle")}</p>

                <div className={styles.selectWrapper}>
                    <select
                        className={styles.select}
                        value={selected}
                        onChange={(e) => setSelected(e.target.value)}
                    >
                        <option value="">{t("externalportal.breedselect.placeholder")}</option>
                        {breeds.map((breed) => (
                            <option key={breed.ID} value={breed.ID}>
                                {breed.NAME}
                            </option>
                        ))}
                    </select>
                </div>

                <button
                    className={styles.confirmButton}
                    disabled={!selected}
                    onClick={handleConfirm}
                >
                    {t("externalportal.breedselect.confirm")}
                </button>
            </div>
        </div>
    );
}

export default BreedSelectOverlay;
